// AddReport.js
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_ConfigCompany from './Icon Config Company.png';
import './App.css';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import iconImage from './Icon Config.png';
import api from './axios'; // je axios-instance


const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


function AddReport() {
    const { user, token, companyId, companyName, logout, updateUser } = useAuth();
    const navigate = useNavigate(); 
    const [menu2Open, setMenu2Open] = useState(false);
    const menu2Ref = useRef(null);
    const [availableReports, setAvailableReports] = useState([]);
    const [myReports, setMyReports] = useState([]);
    const [isItemSelected_AvailableReports, setIsItemSelectedAvailableReports] = useState(false);
    const [isItemSelected_MyReports, setIsItemSelectedMyReports] = useState(false);
    const [licenseModels, setLicenseModels] = useState([]);
    const [selectedReports_AvailableReports, setSelectedReports_AvailableReports] = useState([]);
    const [selectedReports_MyReports, setSelectedReports_MyReports] = useState([]);
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [showQuestionYesNoPopup, setShowQuestionYesNoPopup] = useState(false);
    const [showCommentPopup, setShowCommentPopup] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('Support');
    const [Request_message, setRequestMessage] = useState("");
    const [showHelpPopup, setShowHelpPopup] = useState(false);
    const [progressMessage, setProgressMessage] = useState("");

    
    const handleSendHelpButton = async (event) => {
        event.preventDefault();
      
        // gebruik user uit context in plaats van localStorage
        const { id: user_id, email: user_email, name: user_name, token } = user;
        // gebruik companyId en companyName uit state/context
        const company_id   = companyId;
        const company_name = companyName;
      
        // sluit de help-popup
        setShowHelpPopup(false);
      
        try {
          // axios-instance 'api' stuurt automatisch Authorization header
          await api.post('/api/requestforsupport', {
            user_id,
            user_email,
            user_name,
            company_id,
            company_name,
            Request_category: selectedCategory,
            Request_message,
            currentURL: window.location.href
          });
      
          setMessage('Request for support sent successfully');
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
        } catch (err) {
          if (err.response?.status === 401) {
            // token verlopen: logout via context
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${company_id}`);
            return;
          }
      
          // andere foutmelding
          const msg = err.response?.data?.error || err.message;
          setError(`Error sending request for support: ${msg}`);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      };      

    const handleMyProfile = () => {
        navigate('/my-profile');
      };
      
    // vervang je bestaande handleIconClick door deze versie:
    const handleIconClick = (reportId) => {
        // gebruik companyId uit state/context in plaats van localStorage
        navigate(`/configcompanyreport/${companyId}/${reportId}`);
    };
  
    
    // Functie die wordt aangeroepen wanneer een checkbox wordt aangevinkt/uitgevinkt
    const handleItemSelectAvailableReports = (reportId, isChecked, e) => {
        e.stopPropagation();

        let updatedReports;
    
        if (isChecked) {
            updatedReports = [...selectedReports_AvailableReports, reportId];
            setSelectedReports_AvailableReports(updatedReports);
        } else {
            updatedReports = selectedReports_AvailableReports.filter(id => id !== reportId);
            setSelectedReports_AvailableReports(updatedReports);
        }
    };
    
    

    // Functie die wordt aangeroepen wanneer een checkbox wordt aangevinkt/uitgevinkt
    const handleItemSelectMyReports = (reportId, isChecked2, e) => {
        e.stopPropagation();

        let updatedReports2;
        console.log("handleItemSelectMyReports called with", reportId, isChecked2);
        if (isChecked2) {
            updatedReports2 = [...selectedReports_MyReports, reportId];
            setSelectedReports_MyReports(updatedReports2);
            console.log("Updated selectedReports_MyReports:", updatedReports2);
        } else {
            updatedReports2 = selectedReports_MyReports.filter(id => id !== reportId);
            setSelectedReports_MyReports(updatedReports2);
        }
    }

    const handleAddSelectedReports = async () => {
        setIsLoading(true);
      
        const userId = user.id;
        const companyRoleId = user.company_roleId;
        const compId = companyId;
      
        let addedCount = 0;
        let existingCount = 0;
      
        for (let i = 0; i < selectedReports_AvailableReports.length; i++) {
          const reportId = selectedReports_AvailableReports[i];
          try {
            const { data } = await api.post('/api/addSelectedReports', {
              reports: [reportId],
              user_id: userId,
              company_id: compId,
              company_role_id: companyRoleId,
            });
      
            addedCount += data.added;
            existingCount += data.existing;
            setProgressMessage(`${i + 1} of ${selectedReports_AvailableReports.length} selected reports added`);
          } catch (err) {
            // axios will throw for non-2xx, including 401
            if (err.response?.status === 401) {
              await logout();
              setError('Session expired');
              setShowErrorPopup(true);
              setTimeout(() => setShowErrorPopup(false), 3000);
              navigate(`/login/${companyId}`);
              return;
            }
            console.error('Error adding report:', err);
          }
        }
      
        setSelectedReports_AvailableReports([]);
      
        try {
          const { data: refresh } = await api.get(`/api/myreports/${userId}/${companyId}`);
          setMyReports(refresh.reports || []);
        } catch (err) {
          console.error('Error fetching my reports:', err);
        }
      
        setIsLoading(false);
      
        if (addedCount === 0) {
          setMessage('Report(s) already existing, nothing added');
        } else {
          setMessage(`You have successfully added ${addedCount} report(s) (${existingCount} existing)`);
        }
      
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 3000);
        setProgressMessage('');
      };     
    

      async function handleActivateSelectedReports() {
        try {
          // Voor elk geselecteerd rapport, roep de API aan via je axios-instance (api)
          for (const cruId of selectedReports_MyReports) {
            await api.put('/api/activate_report', { cru_id: cruId });
          }
      
          // Succesmelding tonen
          setMessage("Report(s) activated successfully!");
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
          // Reset selectie
          setSelectedReports_MyReports([]);
      
          // MyReports opnieuw ophalen
          const { data } = await api.get(`/api/myreports/${user.id}/${user.default_companyid}`);
          setMyReports(data.reports || []);
        } catch (err) {
          // Session expired?
          if (err.response?.status === 401) {
            logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${user.default_companyid}`);
            return;
          }
      
          console.error("Error activating reports:", err);
          setError(`Something went wrong during activating report(s): ${err.message}`);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      }
      
    // Deze functie roept je backend API aan om een rapport te activeren
    async function activateReport(cruId) {
        try {
        const { data } = await api.put('/api/activate_report', {
            cru_id: cruId
        });
        return data;
        } catch (err) {
        if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return;
        }
        // voor andere fouten
        throw new Error(err.response?.data?.error || 'Something went wrong during activating report');
        }
    }
  
    // Deze functie roept je backend API aan om een rapport te verwijderen
    async function deleteReport(cruId, companyId) {
        try {
        const { data } = await api.post('/api/deleteSelectedReports', {
            cru_id: cruId,
            company_id: companyId
        });
        return data;
        } catch (err) {
        if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
            return;
        }
        throw new Error(err.response?.data?.error || 'Something went wrong during deleting report');
        }
    }
  
    async function handleDeleteSelectedReports() { 
        setIsLoading(true);
        const user_id = user.id;
        const company_id = user.default_companyid;
        
        try {
          // Voor elk geselecteerd rapport, roep de API aan
          for (const cruId of selectedReports_MyReports) {
            await deleteReport(cruId, company_id);
          }
      
          // Na succesvol verwijderen…
          setMessage("Report(s) deleted successfully!");
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000);
      
          // Leeg de selectie
          setSelectedReports_MyReports([]);
      
          // Haal de bijgewerkte lijst op met je axios-instance
          const { data } = await api.get(`/api/myreports/${user_id}/${company_id}`);
          setMyReports(data.reports || []);
        } catch (err) {
          // 401 afhandelen via AuthContext
          if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${company_id}`);
            return;
          }
          console.error("Something went wrong during deleting report(s):", err);
          setError('Something went wrong during deleting report(s): ' + (err.response?.data?.error || err.message));
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        } finally {
          setIsLoading(false);
        }
      }
      

    const handleMenu_Help = () => {
        setShowHelpPopup(true);
      };

    useEffect(() => {
        setIsItemSelectedAvailableReports(selectedReports_AvailableReports.length > 0);
    }, [selectedReports_AvailableReports]);

    useEffect(() => {
        setIsItemSelectedMyReports(selectedReports_MyReports.length > 0);
    }, [selectedReports_MyReports]);

    useEffect(() => {
        if (!user) return;
      
        const fetchData = async () => {
          try {
            const { data } = await api.get(
              `/api/availablereportsmyreports/${user.id}/${user.default_companyid}`
            );
      
            setAvailableReports(data.availablereports ?? []);
            setMyReports(data.myreports ?? []);
            setUserRole(data.roleId ?? 3);
      
            // Clear any “newReportName” flag in your AuthContext
            if (user.newReportName) {
              updateUser({ ...user, newReportName: null });
            }
          } catch (err) {
            // If unauthorized, kick off the logout flow from your AuthContext
            if (err.response?.status === 401) {
              await logout();
              navigate(`/login/${user.default_companyid}`);
              return;
            }
            console.error("Error fetching reports:", err);
          }
        };
      
        fetchData();
      }, [user, updateUser, logout, navigate]);
      
    
      const handleLogout = () => {
        logout();  
        navigate(`/login/${user.default_companyid}`);
      };
      
    
      const handleSwitchCompany = () => {
        navigate('/my-companies');
      };

      const handleClickOutside = (event) => {
        if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
          setMenu2Open(false);
        }
      };
    
      useEffect(() => {    
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, [user, handleClickOutside]);
          
        // Als de gebruiker niet is ingelogd, render dan niets

  if (!user) 
  {
    //navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina // Redirect naar de loginpagina
    return null;
  }

  const userString = localStorage.getItem('user');
  const newReportNames = user && user.newReportName ? user.newReportName.split(';') : [];

  return (
    <div className="add-report-page">
        <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <button className="back-button" onClick={() => navigate(-1)}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
                <div className="my-companies-title">Add report</div>

                <div style={{ position: 'relative' }}>
                <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
                <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
                {menu2Open && (
                    <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                    <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                    <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                    <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                        {companyName || 'No company assigned'}
                        {
                            user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                            <a href={`/configcompany/${localStorage.getItem('companyId')}`}>
                                <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                            </a>
                            )
                        }
                    </div>            
                    <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                    <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
                    <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
                    <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                    </div>
                )}
                </div>
            </div>
        </header>

        <main className = 'add-report-page-main'>
            {/* De inhoud van je AddReport pagina */}
            <div className="report-table-container">
                <h3>Available Reports</h3>

                {/* Tabel voor de koppen */}
                <table className="report-table-1">
                    <thead>
                        <tr>
                            <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '50px' }}>Select</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Report name</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Keywords</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Supplier</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>License models</th>
                        </tr>
                    </thead>
                </table>

                {/* Scrollbare div rond de tabel met de rijen */}
                <div className="scrollable-table-container">
                    <table className="report-table-2">
                        <tbody>
                            {availableReports.map(report => (
                                <tr key={report.id}>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '50px' }}><input type="checkbox" onChange={(e) => handleItemSelectAvailableReports(report.id, e.target.checked, e)} checked={selectedReports_AvailableReports.includes(report.id)} /></td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>
                                        {report.name}
                                        {newReportNames.includes(report.name) && <span className="new-indicator">New</span>}
                                    </td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report.keywords}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report.owner_company_name}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '250px' }}>{report.license_models}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div class="spacer-20"></div>
                <button className={isItemSelected_AvailableReports ? 'activeButton' : 'inactiveButton'} onClick={handleAddSelectedReports}>
                    Add selected reports
                </button>
            </div>

            <div className="separator"></div>
            <div className="report-table-container">
                <h3>My Reports</h3>
                <table className="report-table-1">
                    <thead>
                        <tr>
                            <th style={{ verticalAlign: 'middle', textAlign: 'center', width: '50px' }}>Select</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Report Name</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Keywords</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>Supplier</th>
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>License</th>
                            {/*}
                            <th style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>
                                { userRole !== 3 && 
                                    <div> 
                                      Config settings
                                    </div>
                                }
                            </th>
                            */}
                        </tr>
                    </thead>
                </table>

                {/* Scrollbare div rond de tabel met de rijen */}
                <div className="scrollable-table-container">
                    <table className="report-table-2">
                        <tbody>
                            {myReports && myReports.length > 0 && myReports.map(report2 => (
                                <tr key={report2.cru_id}>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '50px' }}><input type="checkbox" onChange={(e) => handleItemSelectMyReports(report2.id, e.target.checked, e)} checked={selectedReports_MyReports.includes(report2.id)} /></td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report2.report_name || ""}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report2.keywords || ""}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '300px' }}>{report2.company_name_reportowner || ""}</td>
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '250px' }}>
                                        {report2.active === 0 ? 'Free' : 'Active'}
                                    </td>
                                    {/*
                                    <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>
                                        { userRole !== 3 && 
                                            <img 
                                                src={iconImage} 
                                                alt="Icoon" 
                                                style={{cursor: 'pointer', width: '20px'}} 
                                                onClick={() => handleIconClick(report2.report_id)}
                                            />
                                        }
                                    </td>
                                    */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div class="spacer-20"></div>
                { userRole === 1 && true === false && // true === false zorgt ervoor dat deze knop (tijdelijk?) is uitgeschakeld
                <button className={isItemSelected_MyReports ? 'activeButton' : 'inactiveButton'} onClick={handleActivateSelectedReports}>
                    Activate selected reports
                </button>
                }
                <button 
                    className={isItemSelected_MyReports ? 'activeButton' : 'inactiveButton'} 
                    onClick={() => setShowQuestionYesNoPopup(true)}
                >
                    Delete selected reports
                </button>
            </div>
            {showPopupMessage && <div className="popup-message">{message}</div>}
            {showErrorPopup && <div className="popup">{error}</div>}
            {isLoading && 
                <div className="loader-wrapper">
                <div className="loader"></div>
                </div>
            }
            {progressMessage && <div className="popup-message">{progressMessage}</div>}
            {showQuestionYesNoPopup && (
                <div className="popup-container">
                    <div className="popup-content">
                    <h3 style={{ fontWeight: 'normal' }}>Are you sure you want to delete the selected report(s)?</h3>
                    <div className="white-space"></div>
                    <div className="buttons-container">
                    <button onClick={() => {
                        handleDeleteSelectedReports();
                        setShowQuestionYesNoPopup(false);
                    }} style={{ color: 'black', fontWeight: 'bold' }}>
                        Yes
                    </button>
                    <button onClick={() => {
                        setShowQuestionYesNoPopup(false);
                    }} style={{ color: 'black', fontWeight: 'bold' }}>
                        No
                    </button>
                    </div>
                    {showCommentPopup && <div className="popup">{error}</div>}
                    </div>
                </div>
            )}

            {showHelpPopup && (
                <div className="popup-container">
                    <div className="popup-content">
                    <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
                    <div className="white-space"></div>
                    <b>From:</b>
                    <input
                        type="text"
                        placeholder="Username"
                        className="company-name-input"
                        disabled="true"
                        value={user.name || ""}
                    />
                    <b>Company:</b>
                    <input
                        type="text"
                        placeholder="Company name"
                        className="company-name-input"
                        disabled="true"
                        value={companyName || ""}
                    />
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                        <select 
                        style={{ display: 'inline-block', width: '150px' }}
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        <option value="Support">Support</option>
                        <option value="Customization request">Customization request</option>
                    </select>
                    </div>
                    <div className="white-space"></div>
                    <div className="white-space"></div>
                    <b>Message:</b>
                    <div className="white-space"></div>
                    <textarea
                        placeholder="Request for support message"
                        className="company-name-input"
                        rows="4"
                        value={Request_message}
                        style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                        onChange={(e) => setRequestMessage(e.target.value)}
                    ></textarea>
                    <div style={{ height: '50px' }}></div>
                    <div className="buttons-container">
                        <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                            Cancel
                        </button>
                        <button
                        onClick={handleSendHelpButton}
                        style={{ color: 'black', fontWeight: 'bold' }}
                        >
                        Send request
                        </button>
                    </div>
                    </div>
                </div>
            )}
        </main>
    </div>
  );
}

export default AddReport;
